import React from 'react';
import styles from './styles.module.scss';
import DownArrow from './down_arrow.svg';
import enhance from './enhance';

const FilterSection = ({
  headerText,
  children,
  isVisible,
  setIsVisible,
  arrowStyles,
}) => {
  return (
    <div>
      <div className={styles.header} onClick={setIsVisible}>
        <img src={DownArrow} alt="down arrow" className={arrowStyles} />
        <span data-test="headerText">{headerText}</span>
      </div>
      {isVisible && (
        <div className={styles.content} data-test="drawer">
          {children}
        </div>
      )}
    </div>
  );
};

export default enhance(FilterSection);
